import { createSlice } from '@reduxjs/toolkit';

import { createOrganisation as createOrganisation } from '@/domain/organisation/actions/create-organisation.action';
import { editOrganisation as editOrganisation } from '@/domain/organisation/actions/edit-organisation.action';
import { getOrganisation } from '@/domain/organisation/actions/get-organisation.action';
import { Organisation } from '@/domain/organisation/entities/organisation.entity';

export type OrganisationState = {
  isOrganisationSet: boolean;
  organisationInfos: Organisation;
  isFetchingOrganisation: boolean;
  isCreatingOrganisation: boolean;
  isEditingOrganisation: boolean;
};

const initialState: OrganisationState = {
  isOrganisationSet: false,
  organisationInfos: {
    id: -1,
    logo: '',
    name: '',
    type: '',
    activity: '',
    location: '',
    address: '',
    zipCode: '',
    country: '',
    website: '',
  },
  isFetchingOrganisation: false,
  isCreatingOrganisation: false,
  isEditingOrganisation: false,
};

export const organisationSlice = createSlice({
  name: 'organisation',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getOrganisation.pending, (state) => {
        state.isFetchingOrganisation = true;
      })
      .addCase(getOrganisation.fulfilled, (state, action) => {
        state.isFetchingOrganisation = false;
        const organisation = action.payload;
        if (organisation === null) {
          state.isOrganisationSet = false;
        } else {
          state.isOrganisationSet = true;
          state.organisationInfos = organisation;
        }
      })
      .addCase(getOrganisation.rejected, (state) => {
        state.isFetchingOrganisation = false;
      })
      .addCase(createOrganisation.pending, (state) => {
        state.isCreatingOrganisation = true;
      })
      .addCase(createOrganisation.fulfilled, (state) => {
        state.isCreatingOrganisation = false;
        state.isOrganisationSet = true;
      })
      .addCase(createOrganisation.rejected, (state) => {
        state.isCreatingOrganisation = false;
      })
      .addCase(editOrganisation.pending, (state) => {
        state.isEditingOrganisation = true;
      })
      .addCase(editOrganisation.fulfilled, (state) => {
        state.isEditingOrganisation = false;
        state.isOrganisationSet = true;
      })
      .addCase(editOrganisation.rejected, (state) => {
        state.isEditingOrganisation = false;
      });
  },
});
